import { Component } from '@angular/core';
import { LegalModalsService } from '../services/legal-modals.service';

@Component({
  selector: 'loyaltic-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent {
  constructor(private readonly legalModalsService: LegalModalsService) {}

  openRulesModal(): void {
    this.legalModalsService.openRules();
  }

  openPolicyModal(): void {
    this.legalModalsService.openPolicy();
  }
}
